import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Panel} from "primereact/panel";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import {Column} from "primereact/column";
import {DataTable} from 'primereact/datatable';
import {Button} from "primereact/button";
import axios from "axios";
import {BlockUI} from "primereact/blockui";

const PurchaserequestitemDndComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [formData, setFormData] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [items, setItems] = useState([]);
  const [substitutions, setSubstitutions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [materialCategories, setMaterialCategories] = useState([]);
  const [draggingMaterialIds, setDraggingMaterialIds] = useState([]);
  const [draggingMaterialLabel, setDraggingMaterialLabel] = useState('');
  const [dragOverRequestTable, setDragOverRequestTable] = useState(false);
  const [itemStatuses, setItemStatuses] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const isDoneOrOrdered = (window.App.state?.purchaserequestStatus ||formData?.status || '').toUpperCase() === 'DONE' || 
    (window.App.state?.purchaserequestStatus ||formData?.status || '').toUpperCase() === 'ORDERED';

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoadingMaterials(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const active = 'search[status][operator]==&search[status][value]=ACTIVE';
      const finalQuery = (query || '?') + (query ? '&' : '') + active;
      apiCall('GET', '/api/v2/material' + finalQuery)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setMaterials(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingMaterials(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = { ...lazyParams, ...event };
    _lazyParams.first = 0;
    _lazyParams.page = 0;
    setLazyParams(_lazyParams);
  };
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const categoryFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value ?? null}
        options={materialCategories}
        optionLabel="name"
        optionValue="id"
        // onChange={(e) => options.filterApplyCallback(e.value)}
        onChange={(e) => {
          const value = e.value === undefined ? null : e.value;
          options.filterApplyCallback(value);
        }}
        placeholder={t('allCategoriesPlaceholder')}showClear
        className="p-column-filter"
      />
    );
  };

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtItems = useRef(null);
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'position',
    sortOrder: 1,
    filters: {
      purchase_order_request: {value: id, matchMode: 'equals'}
    }
  });

  let loadLazyTimeoutItems = null;
  const loadLazyDataItems = () => {
    setLoadingItems(true);
    if (loadLazyTimeoutItems) {
      clearTimeout(loadLazyTimeoutItems);
    }
    loadLazyTimeoutItems = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsItems)
      if (id) {
        apiCall('GET', '/api/v2/purchase-order-request-item' + query + '&search[purchase_order_request][operator]=%3D&search[purchase_order_request][value]=' + id)
          .then(response => {
            setTotalRecordsItems(response.data.data.total_item_count);
            setItems(response.data.data.items)
            const total = response.data.data.total_item_count;
            setTotalRecordsItems(total);
            setItems(response.data.data.items);
            window.App.setState({
              ...window.App.state,
              purchaserequestitemCount: total,
            })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
          .finally(() => {
            setLoadingItems(false);
          })
      } else {
        setLoadingItems(false)
      }
    }, Math.random() * 1000 + 250);
  }
  const onPageItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onSortItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onFilterItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsItems(_lazyParams);
  }
  const pagerItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRowsItems(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const updateRequestItemField = (rowId, fieldName, value) => {
    const el = document.getElementById(`${fieldName}-${rowId}`) || document.getElementById(`${fieldName}_${rowId}`);
    const target = el?.querySelector?.('.p-inputtext') || el;
    if (target) {
      target.style.background = "#ffc107";
      target.style.color = "white";
    }
    if (!rowId || isDoneOrOrdered) return;
    if (!window.requestItemTimeout) window.requestItemTimeout = {};
    if (!window.requestItemErrorShown) window.requestItemErrorShown = {};
    const key = `${rowId}_${fieldName}`;
    if (window.requestItemTimeout[key]) {
      clearTimeout(window.requestItemTimeout[key]);
    }
    window.requestItemTimeout[key] = setTimeout(() => {
      setLoadingItems(true);
      apiCall('patch', `/api/v2/purchase-order-request-item/${rowId}`, {
        [fieldName]: value,
      })
        .then(() => {
          if (target) {
            target.style.background = "#28a745";
            target.style.color = "white";
          }
          window.requestItemErrorShown[key] = false;
        })
        .catch((error) => {
          if (target) {
            target.style.background = "red";
            target.style.color = "white";
          }
          if (!window.requestItemErrorShown[key]) {
            const msg =
              error?.response?.data?.message ||
              error?.response?.data?.error ||
              error?.message ||
              error.toString();
            window.App.toastShow('error', t('error'), msg, '', error.response);
            window.requestItemErrorShown[key] = true;
          }
        })
        .finally(() => {
          setLoadingItems(false);
        });
    }, 400);
  };

  const refreshPurchaserequest = () => {
    const requestId = window.App.urlVars().purchaserequestId ?? id;
    if (!requestId) return;
    apiCall('get', '/api/v2/purchase-order-request/' + requestId)
      .then(res => {
        const data = res.data.data;
        setFormData(data);
        window.App.setState({
          ...window.App.state,
          purchaserequestStatus: data.status,
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  };

  const labelForItemStatus = (key) => {
    if (!key) return '';
    if (!Array.isArray(itemStatuses) || itemStatuses.length === 0) {
      return key; 
    }
    const hit = itemStatuses.find(
      s => String(s.key).toUpperCase() === String(key).toUpperCase()
    );
    return hit?.label || hit?.name || hit?.value || key;
  };

  const handleDragStart = (event, item) => {
    if (isDoneOrOrdered) return;

    let draggedItems = [item];

    if (Array.isArray(selectedMaterials) && selectedMaterials.length > 0) {
      const isPartOfSelection = selectedMaterials.some(sel => sel.id === item.id);
      if (isPartOfSelection) {
        draggedItems = selectedMaterials;
      }
    }
    const draggedIds = draggedItems.map(i => i.id);
    const payload = {
      source: 'materials',
      ids: draggedIds,
    };
    setDraggingMaterialIds(draggedIds);
    setDraggingMaterialLabel(
      draggedItems.length === 1
        ? (draggedItems[0]?.name || '')
        : `${draggedItems.length} tétel`
    );
    event.dataTransfer.setData("application/json", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setDraggingMaterialIds([]);
    setDraggingMaterialLabel('');
    setDragOverRequestTable(false);
  };

  const handleDrop = async (event, target) => {
    event.preventDefault();
    setDragOverRequestTable(false);
    if (target === "right") {
      let raw = event.dataTransfer.getData("application/json") || event.dataTransfer.getData("text/plain");
      if (!raw) return;

      let payload = null;
      try {
        payload = JSON.parse(raw);
      } catch (e) {
        return;
      }

      let ids = [];
      if (payload && Array.isArray(payload.ids)) {
        ids = payload.ids;
      } else if (payload && payload.id) {
        ids = [payload.id];
      } else if (Array.isArray(payload)) {
        ids = payload;
      }
      if (!ids || ids.length === 0) return;
      // Create sequentially in the visible source order; the target sorts by position ascending.
      const itemsToAdd = materials.filter(m => ids.includes(m.id));
      if (itemsToAdd.length === 0) return;
      const delay = (ms) => new Promise(res => setTimeout(res, ms));
      setLoading(true);
      setLoadingItems(true);
      try {
        for (let i = 0; i < itemsToAdd.length; i++) {
          const mat = itemsToAdd[i];
          await apiCall('post', '/api/v2/purchase-order-request-item', {
            purchase_order_request: id,
            material: mat.id,
            quantity: 1,
          });
          if (i < itemsToAdd.length - 1) {
            await delay(10);
          }
        }
        window.App.toastShow('success', 'Sikeres mentés!');
        setLazyParamsItems({
          first: 0,
          rows: rowsItems,
          page: 0,
          sortField: 'position',
          sortOrder: 1,
          filters: {
            purchase_order_request: { value: id, matchMode: 'equals' }
          }
        });
        refreshPurchaserequest();
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        setLoading(false);
        setDraggingMaterialIds([]);
        setDraggingMaterialLabel('');
        setDragOverRequestTable(false);
      }
    }
  };

  const renderDraggableCell = (content, rowData, style = {}) => (
    <div
      draggable={!isDoneOrOrdered}
      onDragStart={(e) => handleDragStart(e, rowData)}
      onDragEnd={handleDragEnd}
      style={{ cursor: isDoneOrOrdered ? 'default' : 'move', ...style }}
    >
      {content}
    </div>
  );

  const handleDragOver = (event) => {
    event.preventDefault();
    //console.log(handleDragOver)
  };

  useEffect(() => {
    if (formData?.status) {
      window.App.setState?.({
        ...window.App.state,
        purchaserequestStatus: formData.status,
      });
    }
  }, [formData?.status]);

  useEffect(() => {
    loadLazyData()
  }, [lazyParams])

  useEffect(() => {
    loadLazyDataItems()
  }, [lazyParamsItems])

  useEffect(() => {
    if (!isDoneOrOrdered) return;
    const t = setTimeout(() => {
      loadLazyDataItems();
    }, 150);
    return () => clearTimeout(t);
  }, [isDoneOrOrdered]);

  useEffect(() => {
    apiCall('GET', '/api/v2/substitution-type')
      .then(response => {
        setSubstitutions(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/material-category')
      .then(response => {
        setMaterialCategories(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('GET', '/api/v2/dictionary/purchase-order-request-item-status')
    .then(response => {
      setItemStatuses(response.data.data);
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    });
    if ((!window.App.urlVars().create && window.App.urlVars().purchaserequestId) || (entity === 'purchase-request' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order-request/' + (window.App.urlVars().purchaserequestId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.state.rerenderPurchaserequestDnd])

  return (
    <div className={"purchaserequest-dnd widget"}>
      {(formData === null || loadingMaterials || loadingItems) && (
      <ProgressBar
        mode="indeterminate"
        style={{
          height: '5px',
          position: "absolute",
          top: 0,
          left: 0,
          borderRadius: 0,
        }}
      />
    )}
      <div className={"p-grid"}>

        {formData === null ? (
          <div className="p-grid">
            <div className="p-col-12">
              <Panel className="p-mt-3">
                <ProgressBar
                  mode="indeterminate"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    fullscreen: true,
                  }}
                />
              </Panel>
            </div>
          </div>
        ) : (
          <>
        {!isDoneOrOrdered && (
        <div className={"p-col-12 p-lg-6"}
             onDragOver={handleDragOver}
             onDrop={(e) => handleDrop(e, "left")}
        >
          <Panel>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('orderableProducts')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
            <BlockUI blocked={(formData.status === 'DONE')}>
              <DataTable
                loading={loadingMaterials}
                emptyMessage={t('noResults')}
                size={"small"}
                value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} filters={lazyParams.filters} lazy
                paginatorTemplate={pager} rows={rows}
                autoLayout={true}
                filterDisplay="row"
                responsiveLayout="scroll"
                stripedRows
                ref={dt}
                rowClassName={(rowData) =>
                Array.isArray(draggingMaterialIds) && draggingMaterialIds.includes(rowData.id)
                    ? 'dnd-drag-source-row-active'
                    : 'dnd-drag-source-row'
                }
                dataKey="id"
                selection={selectedMaterials}
                onSelectionChange={e => setSelectedMaterials(e.value)}
              >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}/>
                <Column field="category" header={t('columnCategory')} sortable filter filterMatchMode="equals" 
                        filterElement={categoryFilterTemplate}
                        body={(rowData) =>
                          renderDraggableCell(rowData?.category?.name, rowData)
                        }
                ></Column>
                <Column field="name" header={t('columnName')} sortable filter
                        body={(rowData) =>
                          renderDraggableCell(
                            <span style={{ fontWeight: '600' }}>
                              {rowData.name}
                            </span>,
                            rowData
                          )
                        }
                ></Column>
                <Column field="manufacturer.name" header={t('columnManufacturer')} sortable filter filterField="manufacturer_name"
                        body={(rowData) =>
                          renderDraggableCell(rowData?.manufacturer?.name, rowData)
                        }
                ></Column>
                <Column field="upc" header={t('upc')} sortable filter
                        body={(rowData) =>
                          renderDraggableCell(rowData.upc, rowData)
                        }
                ></Column>
                <Column field="unit.name" header={t('columnUnit2')} sortable filter filterField="unit_name"
                        body={(rowData) =>
                          renderDraggableCell(rowData.unit?.name, rowData)
                        }
                ></Column>
              </DataTable>
            </BlockUI>
          </Panel>
        </div>
        )}


        <div className={isDoneOrOrdered ? "p-col-12 p-lg-full" : "p-col-12 p-lg-6"} onDragOver={(e) => {
            e.preventDefault();
            if (!isDoneOrOrdered && draggingMaterialIds.length > 0) {
              setDragOverRequestTable(true);
            }
          }}
          onDragLeave={(e) => {
            const related = e.relatedTarget;
            if (!e.currentTarget.contains(related)) {
              setDragOverRequestTable(false);
            }
          }}
          onDrop={(e) => handleDrop(e, "right")}
        >
          <Panel>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('requestedProducts')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
              <DataTable
                loading={loadingItems}
                emptyMessage={t('noResults')}
                size={"small"}
                value={items} paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                onPage={onPageItems}
                onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                paginatorTemplate={pagerItems} rows={rowsItems}
                autoLayout={true}
                filterDisplay="row"
                responsiveLayout="scroll"
                stripedRows
                ref={dtItems}
                dataKey="id"
              >
                {/*<Column field="purchase_order_request.purchase_order_request_number" header={t('columnPurchaseRequestNumber')}*/}
                {/*        sortable filter></Column>*/}
                <Column field="material.name" header={t('columnName')} sortable filter></Column>
                {/* {isDoneOrOrdered ? (
                  <Column field="material.upc" header={t('upc')} sortable filter></Column>
                ) : (
                  <Column field="material.upc" header={t('upc')} sortable filter></Column>
                )} */}
                <Column field="material.upc" header={t('upc')} sortable filter></Column>


                {/*<Column header={t('columnSubstitutionPermission')} body={(rowData) => {*/}
                {/*  return (*/}
                {/*    <InputSwitch*/}
                {/*      className={"p-inputtext-sm"}*/}
                {/*      checked={rowData.substitution_enabled}*/}
                {/*      value={rowData.substitution_enabled}*/}
                {/*      onChange={(e) => {*/}
                {/*        setLoadingItems(true);*/}
                {/*        apiCall('patch', '/api/v2/purchase-order-request-item/' + rowData.id, {*/}
                {/*          substitution_enabled: e.value,*/}
                {/*        })*/}
                {/*          .then(response => {*/}
                {/*            window.App.toastShow('success', 'Sikeres mentés!');*/}
                {/*            loadLazyDataItems()*/}
                {/*          })*/}
                {/*          .catch(error => {*/}
                {/*            window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
                {/*          })*/}
                {/*          .finally(() => {*/}
                {/*            setLoadingItems(false);*/}
                {/*          });*/}
                {/*      }}/>*/}
                {/*  )*/}
                {/*}}></Column>*/}
                <Column header={t('columnSubstitutionReason')} body={(rowData) => {
                  if (isDoneOrOrdered) {
                    return (
                      <span>
                        {rowData.substitution_type?.name}
                      </span>
                    );
                  }
                  return (
                    <Dropdown showClear
                              placeholder={t('noSubstitutionPlaceholder')}
                              onChange={(e) => {
                                setLoadingItems(true);
                                console.log(e)
                                if (e.value === undefined) {
                                  apiCall('patch', '/api/v2/purchase-order-request-item/' + rowData.id, {
                                    substitution_enabled: false,
                                    substitution_type: null,
                                  })
                                    .then(response => {
                                      window.App.toastShow('success', 'Sikeres mentés!');
                                      loadLazyDataItems()
                                    })
                                    .catch(error => {
                                      clearInterval(window.dndInterval[rowData.id]);
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    })
                                    .finally(() => {
                                      setLoadingItems(false);
                                    });
                                } else {
                                  apiCall('patch', '/api/v2/purchase-order-request-item/' + rowData.id, {
                                    substitution_enabled: true,
                                    substitution_type: e.value,
                                  })
                                    .then(response => {
                                      window.App.toastShow('success', 'Sikeres mentés!');
                                      loadLazyDataItems()
                                    })
                                    .catch(error => {
                                      clearInterval(window.dndInterval[rowData.id]);
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    })
                                    .finally(() => {
                                      setLoadingItems(false);
                                    });
                                }
                              }}
                              value={rowData?.substitution_type?.id || rowData?.substitution_type}
                              options={substitutions}
                              optionLabel="name"
                              optionValue="id"
                      //disabled={!rowData.substitution_enabled}
                              id={"substitution-" + rowData.id}
                              emptyMessage={t('noSubstitutionYet')}
                              className={"p-inputtext-sm"}
                    />
                  )
                }}></Column>
                <Column header={t('columnQuantity')} body={(rowData) => {
                  if (isDoneOrOrdered) {
                    return (
                      <span>
                        {rowData.quantity} {rowData.unit?.name || ""}
                      </span>
                    );
                  }
                  return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <InputNumber
                      minFractionDigits={0}
                      maxFractionDigits={9}
                      locale="hu-HU"
                      id={"quantity-" + rowData.id}
                      value={rowData.quantity}
                      className={"p-inputtext-sm"}
                      onKeyUp={(e) => {
                        const rawValue = (e.target.value || '').replace(/\s/g, '').replace(',', '.');
                        const val = rawValue === '' ? null : parseFloat(rawValue);
                        if (window.timerRequestItems) {
                          clearTimeout(window.timerRequestItems);
                        }
                        window.timerRequestItems = setTimeout(() => {
                          setItems(prev =>
                            prev.map(item =>
                              item.id === rowData.id ? { ...item, quantity: val } : item
                            )
                          );
                          updateRequestItemField(rowData.id, 'quantity', val);
                        }, 1500);
                      }}
                      onValueChange={(e) => {
                        const val = e.value;
                        setItems(prev =>
                          prev.map(item =>
                            item.id === rowData.id ? { ...item, quantity: val } : item
                          )
                        );
                        updateRequestItemField(rowData.id, 'quantity', val);
                        if (window.timerRequestItems) {
                          clearTimeout(window.timerRequestItems);
                        }
                      }}
                    />
                    <span>{rowData.unit?.name || ""}</span>
                  </div>
                  )
                }}></Column>
                {isDoneOrOrdered && (
                  <Column header={t('columnStatus2')} field="status" body={(rowData) => labelForItemStatus(rowData.status)}></Column>
                )}
                {!isDoneOrOrdered && (
                <Column body={(rowData) => {
                  return (
                    <React.Fragment>
                      {localStorage.getItem('roles').toString().includes('role_') &&
                        <Button icon="pi pi-trash" className="p-button-danger p-button-sm"
                                tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  if (window.confirm('A törlés megerősítésére van szükség!')) {
                                    setLoadingItems(true);
                                    apiCall('delete', '/api/v2/purchase-order-request-item/' + rowData.id)
                                      .then(response => {
                                        window.App.toastShow('success', 'Sikeres törlés!');
                                        loadLazyDataItems()
                                        refreshPurchaserequest();
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                      })
                                      .finally(() => {
                                        setLoadingItems(false);
                                      })
                                  }
                                }}
                        />
                      }
                    </React.Fragment>
                  );
                }} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
                )}
              </DataTable>
          </Panel>
        </div>
        </>
        )}
      </div>
    </div>
  )
}
export default withTranslation('common')(PurchaserequestitemDndComponent);
